var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReutersLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.3,432.1c-7,0.6-13.7,0.3-20.4,0.3c-1.3-4.5-1.6-92.4-0.4-100.3c1.6-0.9,3.4-0.5,5.2-0.5 c11.8,0,23.6,0,35.5,0c4.6,0,9.2,0.4,13.7,1.7c17.7,5,26.7,20.2,23.9,39.7c-1.2,8.6-4.9,15.1-13.1,18.7c-1.2,0.5-2.7,0.9-3.5,3 c6.2,12.1,12.5,24.5,19.2,37.5c-8.2,0-15.8,0-24,0c-5.5-10.8-11.1-21.8-16.9-33.1c-5.9,0-11.9,0-18.4,0 C321,409.9,322.2,420.8,321.3,432.1z M322,380.3c6.3,0.7,12.1,0.3,17.8,0.3c1.6,0,3.2-0.3,4.7-0.6c8.1-1.9,12.3-7.2,12.1-15.4 c-0.2-7.9-4.9-13.7-12.9-14.8c-7.1-1-14.2-0.4-21.7-0.3C322,359.9,322,369.8,322,380.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M670.8,400c-17.9,0-35.5,0-53,0c-1.3,7.9,2.8,14.5,10.1,16.9c10,3.3,17.9,0.2,23.1-9.2c6.2,0,12.6,0,19.3,0 c-0.9,7.3-4.3,12.8-9.5,17.2c-13.8,11.6-36.3,11.2-51.2-0.6c-16.2-12.8-17-33-9.8-47.8c4.9-10,13.4-15.8,24.2-18 c8.1-1.6,16.4-1.5,24.4,1C665.3,364.7,675,382,670.8,400z M617.7,386.5c10.9,0,21.8,0,32.7,0c-0.7-8.6-6.4-13.7-15.6-14 C625.6,372.1,619.2,377.2,617.7,386.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460.1,400.1c-17.8,0-35.4,0-52.9,0c-1.2,8.1,2.8,14.5,10.2,16.9c10.1,3.3,17.9,0.1,23-9.3 c6.3,0,12.6,0,19.4,0c-1.1,7.8-4.8,13.5-10.6,17.9c-21.7,16.4-56.9,5.9-63.1-21c-5.6-24.6,8.6-45.6,33.7-46.9 c5.2-0.3,10.3,0,15.5,1.2C454.5,363.3,463.9,381.7,460.1,400.1z M407,386.4c11.4,0,22.2,0,33.2,0c-1.9-9.3-7.7-14.1-16.9-14 C414.4,372.6,408.8,377.3,407,386.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.2,358.4c6.8-0.2,13.1-0.5,19.8,0.2c0,24.6,0,48.9,0,73.5c-6,0-11.7,0-17.2,0c-1.9-2.1-1-4.9-2.7-6.8 c-1.6-0.5-2.2,0.8-3,1.5c-9.4,8.5-25.7,7.9-35,2.7c-5.5-3.1-9-7.9-11.1-13.7c-1.2-3.4-2.2-7-2.2-10.5c-0.2-15.4-0.1-30.8-0.1-46.6 c6.6,0,13.1,0,19.4,0c1.3,2.1,0.8,4.1,0.8,6.1c0,10.4,0.1,20.8,0,31.2c0,3,0.3,6,0.9,8.9c1.5,7.1,5.4,10.9,11.9,11.6 c6.8,0.8,12.9-2.5,15.8-8.5c1.9-4.1,2.5-8.4,2.5-12.9c0-10.6,0-21.2,0-31.8C520.9,362,521,360.6,521.2,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730.2,408.5c6.6,0,12.6,0,18.5,0c5.8,10.4,13.2,11.7,24.6,9.6c1.2-0.2,2.3-0.7,3.4-1.2 c2.4-1.2,3.4-3.3,3.4-5.9c0-2.7-1.5-4.4-3.9-5.4c-5.1-2-10.5-2.4-15.8-3.1c-5.2-0.7-10.3-1.5-15.2-3.3c-14.6-5.5-18-22.6-6.6-33.4 c3.1-3,6.8-5.1,10.8-6.2c11.5-3,23-3,34.2,1.5c8.8,3.5,14.3,9.8,15.5,20c-6.6,0.5-12.6,0.3-18.6,0c-5.5-8.5-12.9-11.2-22.3-8.5 c-4.8,1.4-6.2,3.3-6.2,8.8c1.8,2.9,4.9,3.7,8.1,4.4c7,1.6,14.3,1.4,21.3,3.4c1.9,0.5,3.9,1,5.7,1.7c7.5,2.9,12.4,7.8,13,16.3 c0.7,9.5-2.4,17-10.9,21.6c-9.3,5-19.5,5.5-29.8,4.4c-5.6-0.6-11-2-16-4.9C735.9,423.9,731.2,417.8,730.2,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M590.6,358.9c0.7,5.6,0.3,10.7,0.2,15.9c-5.6,1.7-11.2-0.1-16.9,1.5c0,4.8,0,9.6,0,14.3 c0,5.8-0.2,11.6,0.1,17.4c0.2,5.3,2.2,7.1,7.4,7.4c3.2,0.2,6.4,0,9.4,0c1.3,4.7,1.4,9.7,0.4,16.9c-7.6,0-15.3,0.8-23-0.5 c-7.6-1.3-12.4-6-13.9-13.8c-0.5-2.4-0.8-4.7-0.8-7.1c0-22.8,0-45.6,0-68.4c0-1.4,0-2.7,0-4.7c6.9-0.2,13.3-0.4,20.5,0.2 c0,6.8,0,13.3,0,19.8C579.8,359.1,585,357.8,590.6,358.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M726.3,358.4c0.5,6.2,0.3,11.8,0.1,17.4c-2.5,1.5-5.1,0.8-7.6,0.9c-10.4,0.5-15.4,4.8-16.7,15.1 c-1.2,9.6-0.3,19.2-0.6,28.8c-0.1,3.7,0,7.5,0,11.5c-7,0.6-13.3,0.3-20,0.2c0-24.7,0-48.9,0-73.7c5.9-0.7,11.8-0.4,18-0.1 c0.8,3.2,1.5,6.3,2.5,10.3C707.9,360.1,716.2,357.8,726.3,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.7,318.4c-9.1,0.1-16.5-7.1-16.6-16.2c-0.1-9.3,7.3-17.1,16.5-17.2c9.1-0.2,16.7,7.5,16.8,16.8 C226.4,311.5,219.5,318.3,209.7,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.5,479.4c-9.6,0.1-16.6-6.8-16.6-16.6c0-9.4,7.4-16.9,16.7-16.8c8.8,0.1,16.4,7.7,16.6,16.5 C66.2,471.9,58.9,479.3,49.5,479.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.1,263c7.7-0.8,14.6,6.6,14.6,14.1c0,8.3-6.4,14.6-14.9,14.5c-8.1-0.1-14.5-6.5-14.3-14.5 C158.6,268.7,166,262.1,173.1,263z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39,426c0.1,8.1-6.3,14.6-14.3,14.6c-8,0-14.4-6.4-14.5-14.4c-0.1-8.5,6.4-15.3,14.6-14.9 C33.6,411.8,39.3,418,39,426z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.5,487.6c0,8.3-6,14.4-14.3,14.4c-8.3,0.1-14.7-6.4-14.6-14.8c0.1-7.8,6.2-14,14-14.1 C94.2,473.1,100.5,479.2,100.5,487.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.5,353.3c-8.2,0-14.6-6.2-14.7-14.1c-0.1-8.3,6.4-14.8,14.8-14.7c8,0.1,14.4,6.6,14.4,14.5 C249,347,242.6,353.3,234.5,353.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.2,394.8c-7-0.1-12.7-5.7-12.6-12.6c0.1-6.5,5.8-12.1,12.4-12.1c7.1,0,12.4,5.4,12.3,12.6 C255.1,389.8,250,394.9,243.2,394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.7,280.9c-7,0-12.3-5.2-12.4-11.9c-0.1-7.1,5.2-12.7,12.3-12.9c6.7-0.1,12.5,5.8,12.5,12.7 C142,275.5,136.5,280.9,129.7,280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,382.4c0,7.2-5.3,12.6-12.4,12.6c-6.8,0-12-5.4-12.1-12.3c0-7.2,5.2-12.5,12.4-12.5 C23,370.1,28.2,375.4,28.2,382.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.4,508.3c-7.2,0-12.2-5.3-12.1-12.7c0.1-6.8,5.3-11.7,12.5-11.7c6.7,0,12.2,5.5,12.3,12.1 C142.1,503.1,136.7,508.4,129.4,508.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.7,325.8c6.5,0,11.7,5.4,11.5,11.9c-0.2,6.1-5.4,11.3-11.6,11.4c-6,0.1-11.5-5.3-11.6-11.4 C72.9,331.3,78.4,325.7,84.7,325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.5,438.9c-6.2,0.1-11.5-5-11.7-11.1c-0.2-6.8,4.6-11.8,11.3-11.9c6.7-0.1,11.6,4.8,11.6,11.6 C185.7,433.9,180.9,438.8,174.5,438.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.1,266.7c5.8,0.1,10.4,5,10.2,10.9c-0.2,5.6-4.9,10.1-10.6,9.9c-5.4-0.1-10.2-5.3-10-10.7 C75.9,271.1,80.4,266.7,86.1,266.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.7,328.4c5.4,0,10.2,4.9,10.2,10.5c0,5.7-4.6,10.3-10.3,10.3c-5.6,0-10.3-4.7-10.2-10.4 C14.5,333,19.1,328.5,24.7,328.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.8,436c-6.2,0.1-10.4-3.7-10.5-9.7c-0.2-6,4.3-10.5,10.4-10.5c5.8,0,9.8,4.3,9.8,10.5 C244.5,432,240.6,435.9,234.8,436z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.1,487.6c0,5.9-4.4,10.2-10.2,10.3c-5.5,0.1-10.1-4.7-10.1-10.5c0-5.7,4.7-10.3,10.3-10.3 C178.8,477.3,183.1,481.8,183.1,487.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.4,408.1c-4.8-0.1-8.7-4.5-8.5-9.6c0.2-5.2,4.3-9.1,9.2-8.9c4.9,0.3,8.7,4.6,8.6,9.7 C199.7,404.2,195.5,408.2,190.4,408.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.9,434.8c5.2,0,9.1,3.7,9.3,8.9c0.1,5.1-3.8,9.1-9,9.1c-5.2,0.1-9.2-3.7-9.3-8.9 C136.7,439.1,140.9,434.8,145.9,434.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.9,320.8c0.1,5.4-3.5,9.2-8.7,9.2c-5.2,0-9.1-3.8-9.1-9c0-5,3.5-8.7,8.6-8.9 C118.1,312,121.8,315.5,121.9,320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.2,365.8c0.1,5.2-3.8,9.2-8.9,9.1c-5.1-0.1-8.7-3.6-8.9-8.5c-0.2-5.3,3.3-9.2,8.6-9.4 C73.1,356.7,77.2,360.6,77.2,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.2,470.8c-4.4-0.3-7.8-4-7.6-8.4c0.2-4.5,4.4-8,9-7.6c4.5,0.5,7.5,4.1,7.1,8.7 C217.3,468.2,213.9,471.1,209.2,470.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.2,302.3c-0.1,4.7-3.3,7.8-8,7.7c-4.6,0-7.9-3.3-7.8-7.9c0-5,3.3-8.1,8.3-7.9 C54.4,294.3,57.3,297.5,57.2,302.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.9,320.3c0.3-3.7,3.5-6.5,7.3-6.4c4.1,0.2,7.2,3.8,6.9,8.1c-0.3,3.8-4.1,6.8-7.9,6.4 C141.1,327.8,138.5,324.4,138.9,320.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.6,359c4.3-0.2,7.2,2.7,7.2,7c0,4-2.7,6.9-6.5,7.2c-3.9,0.3-7.5-2.9-7.7-6.8 C183.4,362.5,186.5,359.2,190.6,359z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.7,398.8c-0.9,4.2-2.7,7-7,7.2c-3.8,0.2-5.6-1.4-7.7-6.7c1.6-5.5,3.1-7.2,7-7.4 C71.9,391.5,73.6,393.1,75.7,398.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.3,443.6c0.1,3.8-3.2,7.4-6.9,7.5c-4,0.1-7.1-3-7.2-7.1c-0.1-4.2,2.7-7.3,6.8-7.5 C116.6,436.3,120.2,439.7,120.3,443.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.4,337.8c-0.2,3-2.5,5.1-5.5,4.9c-2.8-0.2-5.1-3-4.8-5.7c0.2-2.7,3-5.1,5.7-4.9 C177.7,332.3,179.6,334.6,179.4,337.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.2,427.6c-2.3,4.2-4,5.4-6.8,4.6c-2.7-0.7-4-2.7-3.8-5.4c0.2-2.6,1.7-4.6,4.5-4.9 C87.7,421.7,89.4,424,90.2,427.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReutersLogo);
export default __webpack_public_path__ + "static/media/ReutersLogo.8190756403d389d00084b50451cd5f40.svg";
export { ForwardRef as ReactComponent };